import axios from "axios";
import {
  getAccessToken,
  getRefreshToken,
  clearAuthTokens,
} from "context/OAuth/authService";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await fetch(
          `${process.env.REACT_APP_WORDPRESS_URL}/wp-json/enhanced-sso/v1/refresh-token`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ token: localStorage.getItem("access_token") }),
          }
        );

        const data = await refreshResponse.json();

        if (refreshResponse.ok && data?.token) {
          localStorage.setItem("access_token", data.token);
          originalRequest.headers["Authorization"] = `Bearer ${data.token}`;
          return axiosInstance(originalRequest);
        } else {
          throw new Error(data?.error || "Refresh logic failed");
        }
      } catch (err) {
        clearAuthTokens();
        if (window.location.pathname !== "/login") {
          window.location.href = "/login";
        }
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;









// import axios from "axios";
// import {
//   getAccessToken,
//   getRefreshToken,
//   clearAuthTokens,
// } from "context/OAuth/authService";
// import { useResetStore } from "@utils/reserStore";

// const axiosInstance = axios.create({
//   baseURL: process.env.REACT_APP_BACKEND_BASE_URL,
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = getAccessToken();
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;

//     if (error.response?.status === 401 && !originalRequest._retry) {
//       originalRequest._retry = true;

//       try {
//         const refreshResponse = await fetch(
//           `${process.env.REACT_APP_WORDPRESS_URL}/wp-json/enhanced-sso/v1/refresh-token`,
//           {
//             method: "POST",
//             headers: {
//               "Content-Type": "application/json",
//             },
//             body: JSON.stringify({ token: localStorage.getItem("access_token") }), // use refresh token here
//           }
//         );

//         const data = await refreshResponse.json();
//         if (data?.token) {
//           // Store new token
//           localStorage.setItem("access_token", data.token);

//           originalRequest.headers["Authorization"] = `Bearer ${data.token}`;

//           return axiosInstance(originalRequest); 
//         } else {
//           console.error("Token refresh failed:", data?.error || "Unknown error");
//           clearAuthTokens();
//           useResetStore();
//           window.location.href = "/login";
//         }
//       } catch (err) {
//         console.error("Token refresh error:", err);
//         clearAuthTokens();
//         useResetStore();
//         window.location.href = "/login";
//       }
//     }

//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;
